<template>
  <el-row>
    <el-col :span="12">
      <dan v-for="(item, index) in dans" :key="index" :data="item" :selectedDans="selectedDans"
        @selected="wrapHandleSelected" />
      <div class="ml10">
        <el-button type="primary" @click="wrapHandleOverKing" size="mini" plain>王者上星</el-button>
      </div>
    </el-col>
    <el-col :span="12">
      <el-form ref="form" label-width="70px" label-position="left" size="mini">
        <el-form-item label="区服">
          <el-radio-group v-model="zone" size="mini">
            <el-radio-button border label="ANDRIOD">安卓</el-radio-button>
            <el-radio-button border label="IOS">IOS</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="server" size="mini" style="margin-left: 10px">
            <el-radio-button border label="QQ">QQ</el-radio-button>
            <el-radio-button border label="WECHAT">微信</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="铭文">
          <el-radio-group v-model="inscriptionId" size="mini">
            <el-radio-button border v-for="(item, index) in inscriptions" :key="index" :label="item.id">{{ item.start
              }}-{{ item.end }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="起始段位">
          <DanSelect ref="startDanSelect" :label="starCount.startStar.label" :count.sync="starCount.startStar.count"
            :max-count="selectedDans[0] == null ? 5 : selectedDans[0].starCount" :on-focus="changeStartCount"
            :on-change="changeStartCount" unit="星" />
        </el-form-item>

        <el-form-item label="结束段位">
          <DanSelect :label="starCount.endStar.label" :count.sync="starCount.endStar.count"
            :max-count="selectedDans[1] == null ? 5 : selectedDans[1].starCount" :on-focus="changeEndCount"
            :on-change="changeEndCount" unit="星" />
        </el-form-item>
        <el-form-item label="星颗数">
          <span style="color: red; font-size: 16px; font-weight: bold">{{ danStar }}</span>
        </el-form-item>
        <el-form-item label="折扣">
          <el-radio-group v-model="discount" size="mini">
            <el-radio-button border v-for="(item, index) in discounts" :key="index" :label="item.discount">
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="其他选项">
          <span>
            <span class="desc_text">包含预计时间</span>
            <el-switch v-model="showEstimateTime"></el-switch>
          </span>
          <span style="margin-left: 10px">
            <span class="desc_text">包含首段报价</span>
            <el-switch v-model="showFirstDan"></el-switch>
          </span>
        </el-form-item>

        <div style="font-size: 13px" class="mt10"></div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import Dan from '../Dan';
import DanSelect from '../DanSelect.vue';

export default {
  name: 'KingForm',
  components: {
    Dan,
    DanSelect,
  },
  props: {
    zone: {
      type: String,
      default: 'ANDRIOD',
    },
    server: {
      type: String,
      default: 'QQ',
    },
    inscriptionId: {
      type: Number,
      default: 0,
    },
    inscriptions: {
      type: Array,
      default: () => [],
    },
    starCount: {
      type: Object,
      default: () => ({
        startStar: {
          label: '起始',
          count: 1,
        },
        endStar: {
          label: '结束',
          count: 1,
        },
      }),
    },
    selectedDans: {
      type: Array,
      default: () => [],
    },
    danStar: {
      type: Number,
      default: 0,
    },
    showEstimateTime: {
      type: Boolean,
      default: true,
    },
    showFirstDan: {
      type: Boolean,
      default: true,
    },
    discount: {
      type: [String, Number, null],
      default: null,
    },
    discounts: {
      type: Array,
      default: () => [],
    },
    changeStartCount: {
      type: Function,
      default: () => { },
    },
    changeEndCount: {
      type: Function,
      default: () => { },
    },
    dans: {
      type: Array,
      default: () => [],
    },
    handleSelected: {
      type: Function,
      default: () => { },
    },
    handleOverKing: {
      type: Function,
      default: () => { },
    },
  },
  watch: {
    zone(newVal) {
      this.$emit('update:zone', newVal);
    },
    server(newVal) {
      this.$emit('update:server', newVal);
    },
    inscriptionId(newVal) {
      this.$emit('update:inscriptionId', newVal);
    },
    discount(newVal) {
      this.$emit('update:discount', newVal);
    },
    showEstimateTime(newVal) {
      this.$emit('update:showEstimateTime', newVal);
    },
    showFirstDan(newVal) {
      this.$emit('update:showFirstDan', newVal);
    },
  },
  methods: {
    wrapHandleSelected(value) {
      this.handleSelected(value);
      this.$refs.startDanSelect.focus();
    },
    wrapHandleOverKing() {
      this.handleOverKing();
      this.$refs.startDanSelect.focus();
    },
    focus() {
      this.$refs.startDanSelect.focus();
    },
  },
};
</script>

<style scoped>
.desc_text {
  margin-right: 5px;
}
</style>
